import { z } from 'zod'

const schema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(10),
  VITE_PUBLIC_SITE_URL: z.url().optional(),
  VITE_TURNSTILE_SITE_KEY: z.string().optional(),
  VITE_DEMO_SLUG: z.string().optional(),
})

const parsed = schema.safeParse(import.meta.env)
if (!parsed.success) {
  // Fail loudly at startup instead of producing confusing runtime errors.
  console.error('Configuración inválida en variables de entorno', z.treeifyError(parsed.error))
  throw new Error('Faltan variables de entorno VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Revisa .env.local')
}

export const env = {
  supabaseUrl: parsed.data.VITE_SUPABASE_URL,
  supabaseAnonKey: parsed.data.VITE_SUPABASE_ANON_KEY,
  siteUrl: parsed.data.VITE_PUBLIC_SITE_URL ?? window.location.origin,
  turnstileSiteKey: parsed.data.VITE_TURNSTILE_SITE_KEY ?? '',
  /** Public demo salon shown on the landing page (optional). */
  demoSlug: parsed.data.VITE_DEMO_SLUG ?? '',
}
